import React, { useEffect, useState } from 'react';
import DialogComponent from 'app/components/DialogComponent';
import { makeStyles, Grid, IconButton, CircularProgress } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import GetAppIcon from '@material-ui/icons/GetApp';

import styles from './styles';
import CustomPaginationActionsTable from '../TableList/TableList';
import { downloadFile } from 'app/utils/forms/files';
import filesEndpoint from 'app/api/services/filesEndpoint';
import moment from 'moment';
const useStyles = makeStyles(styles);

const LinkDocumento = ({ classes, content, setLoading }) => {
  const handleClick = async () => {
    if (content) {
      let idFile = content.idFile ? content.idFile : content.idFileCrc ? content.idFileCrc : null;
      if (idFile) {
        setLoading(true);
        await downloadFile({ idFile }, null);
        setLoading(false);
      }
    }
  };

  if (!content) return <></>;
  return (
    <>
      <IconButton
        color="primary"
        className={classes.iconDocument}
        size="small"
        onClick={() => handleClick()}
      >
        <GetAppIcon className={classes.icon} />
      </IconButton>
    </>
  );
};

function ModalDocuments(props) {
  const classes = useStyles();
  const { open, onClose, data, title, type } = props;

  const [rows, setRows] = useState([]);
  const [titleModal, setTitleModal] = useState(title);
  const [loading, setLoading] = useState(false);

  const prepareData = content => {
    const date = content.date ? moment.utc(content.date).format('DD/MM/YYYY') : '-';
    const fileName = content.fileName ? content.fileName : '-';
    return {
      originalData: content,
      dtEmissao: <>{date}</>,
      fileName: <>{fileName}</>,
      // deDescricao: <>{content.deDescricao || '-'}</>,
      document: <LinkDocumento {...props} classes={classes} content={content} setLoading={setLoading} />,
    };
  };

  const columns = [
    { title: 'Data emissão', field: 'dtEmissao', align: 'left' },
    { title: 'Arquivo', field: 'fileName', align: 'left' },
    // { title: 'Descrição', field: 'deDescricao', align: 'left' },
    { title: '', field: 'document', align: 'right' },
  ];

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      const rawData = [];
      if (data) {
        if (type === 'veiculos') {
          setTitleModal(`${title} / Veículo ${data.dePlaca}`);
        }else if (type === 'licencas') {
          setTitleModal(`${title} / Licenças ${data.nuLicenca}`);
        }else if (type === 'linhas') {
          setTitleModal(`${title} / Linha ${data.nuLinha}`);
        }
        if (data?.documentos) {
          for (const doc of data.documentos) {
            const tempDocument = { ...doc };
            if (tempDocument.idFile) {
              try {
                const response = await filesEndpoint.getFileData(tempDocument.idFile);
                if (response?.status === 200 && response?.data) {
                  const dataResponse = response.data;
                  tempDocument.date = dataResponse.date;
                  tempDocument.fileName = dataResponse.name;
                }
              } catch (error) {}
            }
            rawData.push(tempDocument);
          }
        }
      }
      setRows(rawData.sort((a,b) => {
        if(moment(a.date).isAfter(moment(b.date))) return 1;
        if(moment(a.date).isBefore(moment(b.date))) return -1;
        return 0;
      }).map(entry => prepareData(entry)));
      setLoading(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <DialogComponent title={titleModal} subtitle={``} open={open} onClose={onClose}>
      <Grid container spacing={1} className={classes.container}>
        {loading && (
          <Grid item xs={12}>
            <div className={classes.centerProgress}>
              <CircularProgress size={20} />
            </div>
          </Grid>
        )}
        {!loading && (
          <CustomPaginationActionsTable
            loading={false}
            columns={columns}
            rows={rows}
            placeholderSearch="Busca"
            pagination={{}}
            onChangePage={() => {}}
            onChangeRowsPerPage={() => {}}
            onBlurSearch={() => {}}
            onChangeSearch={() => {}}
            onClickRow={() => {}}
            hideItemOrder={true}
            hideFilterOrder={true}
            hidePagination={true}
          />
        )}
      </Grid>
    </DialogComponent>
  );
}

export default injectIntl(ModalDocuments);
